import React from 'react';
import iconify from '../iconify';

const ClockIcon = props => (
  <svg width="1em" height="1em" {...props} viewBox="0 0 17.432 17.433">
    <path
      fill={props.currentColor || '#999'}
      d="M16.746,5.325a8.717,8.717,0,1,0,.687,3.392A8.707,8.707,0,0,0,16.746,5.325ZM14.88,11.494a6.756,6.756,0,1,1,.067-5.41h0a6.794,6.794,0,0,1-.067,5.41Z"
      transform="translate(0 0)"
    />
    <path
      fill={props.currentColor || '#999'}
      d="M129.325,54.6h-2.468V50.879a.979.979,0,0,0-1.957,0v4.7a.978.978,0,0,0,.979.979h3.446a.979.979,0,1,0,0-1.957Z"
      transform="translate(-117.308 -46.867)"
    />
  </svg>
);

export default iconify(ClockIcon);
